module.exports = __webpack_public_path__ + "static/media/pinned-tag-green.508e9513.svg";